(function () {
  'use strict';

  function initProductSliderNav(slideshow) {
    if (!slideshow || slideshow.dataset.qlfNavInitialized) return;
    slideshow.dataset.qlfNavInitialized = 'true';

    var section = slideshow.closest('.shopify-section');
    var navContainer = section && section.querySelector('.qlf-product-slider-nav');
    if (!navContainer) return;

    var arrowsWrapper = navContainer.querySelector('.qlf-product-slider-nav-arrows');

    function getControls() {
      return {
        dots:
          slideshow.querySelector('.flickity-page-dots') ||
          navContainer.querySelector('.flickity-page-dots'),
        prevBtn:
          slideshow.querySelector('.flickity-nav.flickity-prev') ||
          (arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav.flickity-prev')),
        nextBtn:
          slideshow.querySelector('.flickity-nav.flickity-next') ||
          (arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav.flickity-next'))
      };
    }

    function removeStaleControls(dots, prevBtn, nextBtn) {
      [slideshow, navContainer].forEach(function (container) {
        if (!container) return;

        container.querySelectorAll('.flickity-page-dots').forEach(function (existingDots) {
          if (existingDots !== dots) {
            existingDots.remove();
          }
        });
      });

      [slideshow, arrowsWrapper].forEach(function (container) {
        if (!container) return;

        container.querySelectorAll('.flickity-nav.flickity-prev').forEach(function (button) {
          if (button !== prevBtn) {
            button.remove();
          }
        });

        container.querySelectorAll('.flickity-nav.flickity-next').forEach(function (button) {
          if (button !== nextBtn) {
            button.remove();
          }
        });
      });
    }

    function moveNav() {
      var controls = getControls();
      var dots = controls.dots;
      var prevBtn = controls.prevBtn;
      var nextBtn = controls.nextBtn;

      removeStaleControls(dots, prevBtn, nextBtn);

      if (dots && dots.parentNode !== navContainer) {
        navContainer.insertBefore(dots, arrowsWrapper);
      }
      if (prevBtn && prevBtn.parentNode !== arrowsWrapper) {
        arrowsWrapper.appendChild(prevBtn);
      }
      if (nextBtn && nextBtn.parentNode !== arrowsWrapper) {
        arrowsWrapper.appendChild(nextBtn);
      }

      var hasDots = dots && dots.querySelectorAll('li').length > 0;
      var hasArrows = arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav');

      if (hasDots || hasArrows) {
        navContainer.style.display = '';
        navContainer.classList.add('qlf-product-slider-nav--ready');
      } else {
        navContainer.style.display = 'none';
        navContainer.classList.remove('qlf-product-slider-nav--ready');
      }
    }

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (attempts > 50) {
        clearInterval(timer);
        return;
      }

      if (typeof Flickity === 'undefined') return;
      var flkty = Flickity.data(slideshow);
      if (!flkty) return;

      clearInterval(timer);
      moveNav();

      flkty.on('change', moveNav);
      flkty.on('settle', moveNav);

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function (mutations) {
          var shouldMove = false;
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (
                node.classList &&
                (node.classList.contains('flickity-page-dots') ||
                  node.classList.contains('flickity-nav'))
              ) {
                shouldMove = true;
              }
            });
          });
          if (shouldMove) setTimeout(moveNav, 10);
        });
        observer.observe(slideshow, { childList: true, subtree: false });
      }
    }, 100);
  }

  function initProductSliderNavForProductPage(slider) {
    if (!slider) return;
    if (slider.__qlfProductSliderNavRefresh) {
      slider.__qlfProductSliderNavRefresh();
      return;
    }
    if (slider.dataset.qlfNavInitialized) return;
    slider.dataset.qlfNavInitialized = 'true';

    var navContainer =
      slider.parentNode && slider.parentNode.querySelector('.qlf-product-slider-nav--product');
    if (!navContainer) return;

    var arrowsWrapper = navContainer.querySelector('.qlf-product-slider-nav-arrows');
    var boundFlickity = null;

    function getControls() {
      return {
        dots:
          slider.querySelector('.flickity-page-dots') ||
          navContainer.querySelector('.flickity-page-dots'),
        prevBtn:
          slider.querySelector('.flickity-nav.flickity-prev') ||
          (arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav.flickity-prev')),
        nextBtn:
          slider.querySelector('.flickity-nav.flickity-next') ||
          (arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav.flickity-next'))
      };
    }

    function removeStaleControls(dots, prevBtn, nextBtn) {
      [slider, navContainer].forEach(function (container) {
        if (!container) return;

        container.querySelectorAll('.flickity-page-dots').forEach(function (existingDots) {
          if (existingDots !== dots) {
            existingDots.remove();
          }
        });
      });

      [slider, arrowsWrapper].forEach(function (container) {
        if (!container) return;

        container.querySelectorAll('.flickity-nav.flickity-prev').forEach(function (button) {
          if (button !== prevBtn) {
            button.remove();
          }
        });

        container.querySelectorAll('.flickity-nav.flickity-next').forEach(function (button) {
          if (button !== nextBtn) {
            button.remove();
          }
        });
      });
    }

    function setReadyState(isReady) {
      navContainer.classList.toggle('qlf-product-slider-nav--ready', !!isReady);
      if (!isReady) {
        navContainer.style.display = 'none';
      } else {
        navContainer.style.display = '';
      }
    }

    function moveNav(retryCount) {
      if (retryCount === undefined) {
        retryCount = 0;
      }

      var controls = getControls();
      var dots = controls.dots;
      var prevBtn = controls.prevBtn;
      var nextBtn = controls.nextBtn;

      if (!dots && !prevBtn && !nextBtn) {
        setReadyState(false);
        if (retryCount < 12) {
          setTimeout(function () {
            moveNav(retryCount + 1);
          }, 30);
        }
        return;
      }

      removeStaleControls(dots, prevBtn, nextBtn);

      if (dots && dots.parentNode !== navContainer) {
        navContainer.insertBefore(dots, arrowsWrapper);
      }
      if (prevBtn && prevBtn.parentNode !== arrowsWrapper) {
        arrowsWrapper.appendChild(prevBtn);
      }
      if (nextBtn && nextBtn.parentNode !== arrowsWrapper) {
        arrowsWrapper.appendChild(nextBtn);
      }

      var hasDots = dots && dots.querySelectorAll('li').length > 0;
      var hasArrows = arrowsWrapper && arrowsWrapper.querySelector('.flickity-nav');

      if (hasDots || hasArrows) {
        setReadyState(true);
      } else {
        setReadyState(false);
      }
    }

    function bindFlickityEvents() {
      if (typeof Flickity === 'undefined') return false;

      var flkty = Flickity.data(slider);
      if (!flkty) return false;

      if (boundFlickity === flkty) {
        return true;
      }

      boundFlickity = flkty;
      flkty.on('change', function () {
        moveNav(0);
      });
      flkty.on('settle', function () {
        moveNav(0);
      });

      return true;
    }

    slider.__qlfProductSliderNavRefresh = function () {
      bindFlickityEvents();
      moveNav(0);
    };

    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (attempts > 50) {
        clearInterval(timer);
        return;
      }

      if (!bindFlickityEvents()) return;

      clearInterval(timer);
      moveNav(0);

      if ('MutationObserver' in window) {
        var observer = new MutationObserver(function (mutations) {
          var shouldMove = false;
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (
                node.classList &&
                (node.classList.contains('flickity-page-dots') ||
                  node.classList.contains('flickity-nav'))
              ) {
                shouldMove = true;
              }
            });
          });
          if (shouldMove) {
            bindFlickityEvents();
            setTimeout(function () {
              moveNav(0);
            }, 10);
          }
        });
        observer.observe(slider, { childList: true, subtree: false });
      }
    }, 100);
  }

  function initAll() {
    document
      .querySelectorAll('.featured-collection .products.carousel, .product-list-section .collection-grid.carousel')
      .forEach(initProductSliderNav);

    document
      .querySelectorAll('.thb-product-detail product-slider')
      .forEach(initProductSliderNavForProductPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 100);
  });

  document.addEventListener('qlf:product-slider-reinit', function (event) {
    var slider = event.target.closest('product-slider') || event.target;
    if (!slider) return;

    setTimeout(function () {
      initProductSliderNavForProductPage(slider);
    }, 0);
  });
})();
